import ToolboxCard, { ToolboxCardType } from '../ToolboxCard';
import OfferCardLink from './components/Link';

interface OfferCardParts {
  Link: typeof OfferCardLink;
}

const OfferCard: OfferCardParts & ToolboxCardType = (props) => (
  <ToolboxCard {...props} />
);

OfferCard.Link = OfferCardLink;

export default OfferCard;
